import { render, staticRenderFns } from "./RandomTop5TagMembers.vue?vue&type=template&id=61609ab4&scoped=true&"
import script from "./RandomTop5TagMembers.vue?vue&type=script&lang=ts&"
export * from "./RandomTop5TagMembers.vue?vue&type=script&lang=ts&"
import style0 from "./RandomTop5TagMembers.vue?vue&type=style&index=0&id=61609ab4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61609ab4",
  null
  
)

export default component.exports